import * as React from "react";
import { NotificationFrequency } from "Components/Users/Settings/Notifications";
import { Col, Row } from "react-bootstrap";
import {Utils} from "../../../common/utils";
import PageTitle from "Components/Common/PageTitle";

export class UserSettings extends React.Component{

    componentDidMount() {
        Utils.setViewName("Preferences", "Preferences");
    }

    renderMenuOptions = () => {
        return (
            <h3>Preferences</h3>
        );
    };

    render(){
        return (
            <React.Fragment>
                <PageTitle pageTitle={"Preferences"} />
                <Row className="section-action-bar">
                    <Col md={12} lg={6} className="title">
                        {this.renderMenuOptions()}
                    </Col>
                </Row>
                <NotificationFrequency />
            </React.Fragment>);
    }
}